import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Column,
  Grid,
  ComboBox,
  DataTable,
  DatePicker,
  DatePickerInput,
  Modal,
  Pagination,
  Select,
  SelectItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TableBatchActions,
  TableBatchAction,
  Theme,
  Row,  
} from 'carbon-components-react';
import { TrashCan } from '@carbon/icons-react';

import { cancelDelegation, getCountriesList, getListMailNameEmployeeByKey, getResoucesForViews, insertApproverDelegation } from '../../services/services';
import SessionController from '../../components/FrontSessionController/SessionController';
import { useNavigate } from "react-router-dom";
import CommodityHeader from '../../components/Header';
import MessageModal from '../../components/MessageModal/MessageModal';

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'personwhodelegates',
    header: 'Person who delegates',
  },
  {
    key: 'delegatedperson',
    header: 'Delegated person',
  },
  {
    key: 'fromdate',
    header: 'From',
  },
  {
    key: 'todate',
    header: 'To',
  },
];

const ApproversDelegation = () => {

  const EMPLOYEE_LIST_SEARCH_INPUT = [
    {
      mail: 'Please enter 3 or more characters',
      disabled: true

    }
  ]
  const EMPLOYEE_LIST_IS_EMPTY =
  [
    {
      mail: 'Not result found',
      disabled: true
    }
  ];

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [createDelegationModal, setCreateDelegationModal] = useState(false);
  const [countryChosen, setCountryChosen] = useState({});
  const [findApproverValue, setFindApproverValue] = useState({});
  const [approverToBeDelegated, setApproverToBeDelegated] = useState();
  const [approverDelegated, setApproverDelegated] = useState();
  const [initDate, setInitDate] = useState();
  const [endDate, setEndDate] = useState();
  const todaysDate = new Date().toLocaleDateString('en-GB');

  const [rows, setRows] = useState([]);

  const [countryList, setCountryList] = useState([]);
  const [listEmp, setListEmp] = useState([]);
  //const [listEmpAux, setListEmpAux] = useState([]);
  const [messageSessionLost, setMessageSessionLost] = useState('');

  const messageResponse = useRef([]);  
  const [messageModal, setMessageModal] = useState('');
  const [listEmployeesToBeDelegated, setListEmployeesToBeDelegated] = useState(EMPLOYEE_LIST_SEARCH_INPUT);
  const [listEmployeesDelegated, setListEmployeesDelegated] = useState(EMPLOYEE_LIST_SEARCH_INPUT);  
   //for showing message and making cursong round for request
   const processingRequest = useRef(false);

  
function debounce(func, delay) {
  let timeout;
  return function(...args) {  // Collect all arguments passed to the debounced function
    clearTimeout(timeout);    // Clear any existing timeout
    timeout = setTimeout(() => {
      func.apply(this, args); // Execute the original function with the correct context and arguments
    }, delay);
  };
}

  
  const getEmployeeList = (inputText,listName) => { 
    if(!isSearchInputForEmployeeValid(inputText,listName))
      return;
    inputText = inputText.toLowerCase();
    let request = {};
    request.clave = inputText;
    getListMailNameEmployeeByKey(request)
    .then(response => {
      if(response.status === 200){
        response.json()
        .then(response => {          
          processResponseForEmployeeSearch(response,listName)          
        })        
      }else if(response.status === 410)   {
        response.text()
        .then(res => {
          setMessageSessionLost(res)                             
        })
      } 
    })          
  }

  const debouncedGetEmployeeList = debounce(getEmployeeList, 300);

  const processResponseForEmployeeSearch = (response,listName) => {
    if(listName === 'employeesToBeDelegated'){
      setListEmployeesToBeDelegated(EMPLOYEE_LIST_IS_EMPTY)
      if(response.length != 0){
        setListEmployeesToBeDelegated(response);
      }
    }else if(listName === 'employeesDelegated'){
      setListEmployeesDelegated(EMPLOYEE_LIST_IS_EMPTY);
      if(response.length != 0){
        setListEmployeesDelegated(response);
      }
    }
  }

  const isSearchInputForEmployeeValid = (inputText, listName) => {        
    if(inputText != undefined && inputText.length < 3){
      if(listName === 'employeesToBeDelegated'){
        setListEmployeesToBeDelegated(EMPLOYEE_LIST_SEARCH_INPUT);
      }else if(listName === 'employeesDelegated'){        
        setListEmployeesDelegated(EMPLOYEE_LIST_SEARCH_INPUT);
      }
      return false;;
    }
    return true;
  }

  const processSelectEmployeeToBeDelegated = (e) => {
    let employeeSelected = '';
    if(e.selectedItem != undefined){
      employeeSelected = e.selectedItem.mail;
    }
    setApproverToBeDelegated(employeeSelected)
  }

  const processSelectEmployeeDelegated = (e) => {
    let employeeSelected = '';
    if(e.selectedItem != undefined){
      employeeSelected = e.selectedItem.mail;
    }
    setApproverDelegated(employeeSelected)
  }

  
  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  function openCreateDelegationModal() {
    setCreateDelegationModal(true);
  };

  function closeCreateDelegationModal() {
    setCreateDelegationModal(false);
  };

  

  function handleDatePicker(date, type) {
    
    const dateParsed = getDateFormated(new Date(date));
    if (type === ("start")) {
      setInitDate(dateParsed);
    } else if (type === ("end")) {
      setEndDate(dateParsed);
    }
    console.log(dateParsed);
  };

  const getDateFormated = (date) =>{
    let dd = String(date.getDate()).padStart(2, '0');
    let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = date.getFullYear();

    return  dd+ '/' + mm + '/' + yyyy;
  }

  const getCountries = async () => await getCountriesList()
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          response.sort((a, b) => a.countryName.localeCompare(b.countryName));
          setCountryList(response);
        })
    }    
  });

  const getDelegations = async (request) => {
    document.body.className = 'waiting';
    await getResoucesForViews(request)
    .then(response => {
      if(response.status === 200){
        response.json()
        .then(response => {
          parserIdInResponse(response);
        })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }       
    });
    document.body.className = '';
  }

  const cancelDelegations = async (params) => {
    if(isRequestActive(true)){
      return;
    } 
    await cancelDelegation(params)
    .then(response => {
      if(response.status === 200){        
        getDelegationList();
      } else if(response.status === 410)   {
        response.text()
        .then(res => {
          setMessageSessionLost(res)                             
        })
      }  
    });
    isRequestActive(false);
  }

  const submitCreate = async (data) => {
    if(isRequestActive(true)){
      return;
    } 
    await insertApproverDelegation(data)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            parserIdInResponse(response);
          })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      }
    });
    isRequestActive(false);
  }
      
    const isRequestActive = (enable) => {
      if(enable){
        if(processingRequest.current){
          openMessageModal('The request is processing');
          return true;
        }
        document.body.className = 'waiting';
        processingRequest.current = enable;      
        return false;
      }else{
        processingRequest.current = enable;
        document.body.className = '';
      }
      return false;
    }

  const processIdsToCancel = (selectedRows) => {
    
    let ids = "";
    for (let index = 0; index < selectedRows.length; ++index) {
      ids = ids + selectedRows[index].id + ";";
    }
    ids = ids.substring(0, ids.length - 1);
    console.log(ids);
    let request = {};
    request.list = ids;
        
    cancelDelegations(request);        
  };

  const parserIdInResponse = (response) => {
    const resParsed = response.vDelegaciones.map((res, i) => {
      const parsed = {};      
      parsed["id"] = "" + res.idInd;
      parsed["ctrycode"] = res.ctrycode;
      parsed["personwhodelegates"] = res.originalApproverName;
      parsed["delegatedperson"] = res.finalApproverName;
      parsed["fromdate"] = res.initialDate;
      parsed["todate"] = res.finalDate;
      return parsed;
    });
    setRows(resParsed);
  };


  function submitCreateDelegation() {    
    if(evaluateAllFields()){
      openMessageModal("Fields can not be left empty");
      return;
    }
    
    let request = {};
    request.pais = countryChosen;
    request.mailapproveroriginal = approverToBeDelegated.trim();
    request.mailapproverfinal = approverDelegated.trim();
    request.fechainicial = initDate;
    request.fechafinal = endDate;
    
    submitCreate(request);
    closeCreateDelegationModal();
    
  };

  const evaluateAllFields = () => {
    if(isFieldIsEmptyOrUndefined(countryChosen) ||
        isFieldIsEmptyOrUndefined(approverToBeDelegated) ||
        isFieldIsEmptyOrUndefined(initDate) ||
        isFieldIsEmptyOrUndefined(endDate) ||
        isFieldIsEmptyOrUndefined(approverDelegated)){
          return true;
    }
    return false;
  }

  const isFieldIsEmptyOrUndefined = (value) => {
    if(value === undefined || value === ''){
      return true;
    }
    return false;
  }

  const getDelegationList = () => {
    let request = {};
    request.viewName = 'delegations';
    getDelegations(request);    
  }


  useEffect(() => {
    getCountries();
    getDelegationList();
    setCountryChosen("613");
    setFindApproverValue("");    
  }, []);

  return (
    <>
      <h2 className="table-title">Approver Delegation</h2>
      <Theme theme="g90">
          <CommodityHeader />
        </Theme>
      <Grid>
        <Modal
          className="createDelegation-Modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Approvers delegation modal"
          modalAriaLabel="Approvers Delegation modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeCreateDelegationModal}
          onRequestSubmit={() => submitCreateDelegation()}
          onSecondarySubmit={closeCreateDelegationModal}
          open={createDelegationModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalHeading={<h3>Approver's Delegation</h3>}
        >
          {<p><strong>Mandatory fields are marked with an asterisk (<h5 className="asterisc">*</h5>) and must be filled out to complete the form.</strong></p>}
          <Grid className="column-addRange">
            <Column lg={16}>
              <Table>
                <TableBody>
                  <Row className={"row-delegation"}>
                    <TableHeader>
                      <h5 className="column-asterisc">For Country <h5 className="asterisc">*</h5></h5>
                    </TableHeader>
                    <Select className="style-select-delegation"
                      labelText=""
                      defaultValue={countryChosen}
                      value={countryChosen}
                      id="country"
                      onChange={(e) => setCountryChosen(e.target.value)}
                    >                      
                      {countryList.map((country) => (
                        <SelectItem value={country.countryCode} text={country.countryName} />
                      ))}
                    </Select>
                  </Row>
                  <Row className={"row-delegation-find-approver"}>
                    <TableHeader>
                      <h5> ID To Be Delegated <h5 className="asterisc">*</h5></h5>
                    </TableHeader>                                    
                    <ComboBox className="style-select-delegation"
                      onChange={(input) => {processSelectEmployeeToBeDelegated(input)}} 
                      onInputChange={(inputText) => debouncedGetEmployeeList(inputText,'employeesToBeDelegated')}
                      id="idComboBoxEmployeeToBeDelegated" 
                      placeholder="Search Approver" 
                      items={listEmployeesToBeDelegated}  titleText="" helperText=""                                                               
                      itemToString={item => item ? item.mail: ''}/>                      
                  </Row>

                  <Row className={"row-delegation"}>
                    <TableHeader>
                      <h5> Delegated <h5 className="asterisc">*</h5></h5>
                    </TableHeader>
                    <ComboBox className="style-select-delegation"
                      onChange={(input) => {processSelectEmployeeDelegated(input)}} 
                      onInputChange={(inputText) => debouncedGetEmployeeList(inputText,'employeesDelegated')}
                      id="idComboBoxEmployeeDelegated" 
                      placeholder="Search Approver" 
                      items={listEmployeesDelegated}  titleText="" helperText=""                                                               
                      itemToString={item => item ? item.mail: ''}/>     
                    <TableHeader>
                      <h5> Date</h5>
                    </TableHeader>
                  </Row>

                  <Row className={"row-delegation-date-picker"}>
                    <DatePicker
                      onChange={(date) => handleDatePicker(date, "start")}
                      minDate={todaysDate}
                      dateFormat="d/m/Y" locale="en" datePickerType="single" className={"date-picker-delegation"}>
                      <DatePickerInput id="date-picker-start" labelText="Delegated from:" placeholder="Start date" />
                    </DatePicker>
                    <DatePicker
                      onChange={(date) => handleDatePicker(date, "end")}
                      minDate={initDate}
                      dateFormat="d/m/Y" locale="en" datePickerType="single" className={"date-picker-delegation"} >
                      <DatePickerInput id="date-picker-end" labelText="Delegated to: " placeholder="End date" />
                    </DatePicker>
                  </Row>
                </TableBody>
              </Table>
            </Column>
          </Grid>

        </Modal>
      </Grid>

      <Grid>
        <Column lg={16} >
        <Button className='style-bttBackHomeDelegation' size="md" onClick={goHomeScreen}>Back to Home</Button>
        <Button className="style-bttCreateDelegation" onClick={openCreateDelegationModal} size="md">Create Delegation</Button>
          <DataTable
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              selectedRows,
              getHeaderProps,
              getRowProps,
              getTableProps,
              getSelectionProps,
              onInputChange,
              getBatchActionProps
            }) => (      
              <TableContainer>
                <label >To remove a delegation you need to first select one</label>
                <TableToolbar className='table-toolbar'>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />                    
                  </TableToolbarContent>
                  <TableBatchActions {...getBatchActionProps()}>
                    <TableBatchAction renderIcon={TrashCan} iconDescription="Delete"
                      onClick={() => { processIdsToCancel(selectedRows); getBatchActionProps().onCancel(); }}> Cancel Delegation
                    </TableBatchAction>
                  </TableBatchActions>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      <TableSelectAll {...getSelectionProps()} />
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header, isSortable: true })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row) => (
                      <TableRow {...getRowProps({ row })}>
                        <TableSelectRow  {...getSelectionProps({ row })} />

                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
          <SessionController messageLostSessionCallback={messageSessionLost} />
          <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
        </Column>
      </Grid>

    </>
  );
};

export default ApproversDelegation;